// Records a person opened last in this browser, for «Недавние» of ⌘K (audit 28.10, L4).

const RECENT = 'confdeck:recent-records';
/** Records the person opened last in this browser, newest first (at most 8); a convenience, so a failing storage is no error. */
export function recentRecords(): string[] {
  try { return (JSON.parse(localStorage.getItem(`${RECENT}:${location.host}`) ?? '[]') as string[]).slice(0, 8); } catch { return []; }
}
export function rememberRecord(id: string): void {
  try { localStorage.setItem(`${RECENT}:${location.host}`, JSON.stringify([id, ...recentRecords().filter((x) => x !== id)].slice(0, 8))); } catch { /* no storage — no recent list */ }
}
